import { EventSchema, getEventList, getProductList } from '@optimizely/opal-app-companion';

type EventMetadataField = {
  name: string;
  properties: string[];
};
// Product types configuration
export const productTypes = getProductList();

// Event types configuration derived from EventSchema
export const eventTypes = getEventList();

// Utility function to get event type label
export const getEventTypeLabel = (value: string) => {
  const eventType = eventTypes.find(type => type.value === value);
  return eventType ? eventType.label : value; // fallback to value if not found
};

export const getEventTypeProduct = (value: string) => {
  const eventType = eventTypes.find(type => type.value === value);
  return eventType
    ? (productTypes.find(product => product.value === eventType.product)?.label ?? null)
    : null;
};

export const getEventMetadata = (eventType: string): EventMetadataField[] => {
  const parts = eventType.split('.');
  const productKey = parts[0];
  const eventKey = parts.slice(1).join('.');

  const productSchema = EventSchema.shape[productKey as keyof typeof EventSchema.shape];
  if (!productSchema) return [];

  const eventSchema = productSchema.shape[eventKey];
  if (!eventSchema || typeof eventSchema !== 'object' || !('shape' in eventSchema)) return [];

  const schemaShape = eventSchema.shape as Record<string, { shape: Record<string, unknown> }>;

  return Object.keys(schemaShape).map(fieldName => ({
    name: fieldName,
    properties: Object.keys(schemaShape[fieldName].shape),
  }));
};
